import { Model } from '@src/models'
import { RUN_INSURANCE_BENEFITS_CHECK } from '@src/graphql/runInsuranceBenefitsCheck'
import FETCH_INSURANCE_POLICIES from '../graphql/fetchInsurancePolicies'
import CREATE_INSURANCE_POLICY from '../graphql/createInsurancePolicy'
import reducers from './insuranceStatus.reducers'

export default class InsuranceStatus {
  namespace = 'insuranceStatus'

  state = {
    ...Model.defaultState,
    insurancePolicies: {
      insurancePolicies: [],
      canCreateNewPolicy: false,
    },
  }

  effects = {
    fetchInsurancePolicies: Model.buildEffect({
      name: `${this.namespace}/fetchInsurancePolicies`,
      query: FETCH_INSURANCE_POLICIES,
      caching: false,
      dataPath: 'insurancePolicies',
      reducers: [{ name: 'updateInsurancePolicies' }],
    }),
    createInsurancePolicy: Model.buildEffect({
      name: `${this.namespace}/createInsurancePolicy`,
      query: CREATE_INSURANCE_POLICY,
      caching: false,
      dataPath: 'createInsurancePolicy',
    }),
    runInsuranceBenefitsCheck: Model.buildEffect({
      name: `${this.namespace}/runInsuranceBenefitsCheck`,
      query: RUN_INSURANCE_BENEFITS_CHECK,
      caching: false,
      dataPath: 'runInsuranceBenefitsCheck',
    }),
  }

  reducers = reducers
}
